// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.padding {\r\n  padding: 1rem;\n}\n.caption {\r\n  background-color: white;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border: dashed;\r\n  border-color: rgba(0, 0, 0, 0.2);\r\n  border-radius: 10px;\n}\n.caption .caption-title {\r\n  text-decoration: underline;\n}\n.pickup-actions-container {\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: -2rem;\r\n  right: 1rem;\n}\n.pickup-actions-container span {\r\n  margin-left: 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
